import React, { useState } from "react";
import Logo from "../../../assets/logo/logo2.png";

const TerroristL = ({ data }) => {
  const [datauserpdf] = useState(data);

  const styles = {
    TittlePDF: {
      color: "#4dcaf3",
      padding: "10px 0px",
      fontsize: "1.6em",
      textalign: "left",
      textAlign: "initial",
      borderBottom: "2px solid",
    },
    boxinfotriPDF: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-around",
      flexWrap: "wrap",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    boxinfotriPDFlast: {
      width: "100%",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    divlabelspam: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "20px 0px",
      width: "33%",
      textAlign: "initial",
    },
    divlabelspamlast: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "20px 0px",
      width: "100%",
      textAlign: "center",
    },
    divlabelspameconomic: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "10px 0px",
      width: "50%",
      textAlign: "initial",
    },
    pagefrompage: {
      margin: "140px 0px 200px 10px",
    },
    pagefrompagemax2: {
      margin: "60px 10px 0px 10px",
    },
    pagefrompageemployer: {
      margin: "50px 10px 0px 10px",
    },
    infopdf: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
    },
    infopdflast: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
      width: "100%",
    },
    tablebackground: {
      borderCollapse: "collapse",
      padding: "10px",
      border: "1px solid #ddd",
      width: "100%",
    },
    headertable: {
      color: "#737373",
      backgroundColor: "#f5f5f5",
      padding: "10px",
      border: "1px solid #ddd",
    },
    headerinfotableabm: {
      backgroundColor: "white",
      border: "1px solid #ddd",
      padding: "10px",
      color: "#737373",
    },

    boxnumbertablevarmatrx: {
      width: "25px",
      height: "25px",
    },

    headerinfotableabmnumber: {
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #ddd",
    },

    header: {
      backgroundColor: "white",
      borderBotton: "1px solid #d1d1d1",
      boxShadow: "0px 10px 5px -3px rgba(0, 0, 0, 0.1)",
      padding: "10px",
      margin: "10px 0px",
      textAlign: "initial",
    },

    logo: {
      width: "200px",
      height: "100px",
    },

    footer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      margin: "30px 0px 0px 0px",
      borderTop: "1px solid #d1d1d1",
    },
    footertext: {
      fontSize: "12px",
      color: "#929292",
    },
    logofooter: {
      width: "100px",
      height: "50px",
    },
    terrorismTitle: {
      fontSize: "2em",
      color: "rgb(34, 66, 104)",
      margin: "50px auto",
      textalign: "center",
    },
    subtittle: {
      fontSize: "1.5em",
      color: "rgb(34, 66, 104)",
      margin: "50px auto",
      textalign: "center",
    },
    boxTittleAndSubtittle: {
      color: "#224268",
      padding: "20px 0px",
      width: "100%",
      textAlign: "center",
    },
  };

  return (
    <div>
      <div style={styles.header}>
        <img src={Logo} style={styles.logo} alt="Logo" />
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <div style={styles.boxTittleAndSubtittle}>
            <p style={styles.terrorismTitle}>Constancia de Terrorismo</p>
            <p style={styles.subtittle}>
              El Sistema Amebo conociendo a su cliente declara que
            </p>
          </div>
          <div style={styles.divlabelspamlast}>
            <span style={styles.infopdflast}>
              {datauserpdf.PoliticalInformation.verification}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.footer}>
        <div>
          <p style={styles.footertext}>
            © 2024. Todos los derechos reservados.
          </p>
        </div>
        <div>
          <img style={styles.logofooter} src={Logo} alt="Logo" />
        </div>
      </div>
    </div>
  );
};

export default TerroristL;
